import { HandleErrorAndLoading } from "@common/handleErrorAndLoading/HandleErrorAndLoading";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import { ChangeEvent, Fragment, ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import "./css/SelectYourNumber.scss";
import { useGetSubscription } from "./hook/useGetSubscription";

interface IParams {
    children: ReactNode;
    noServiceChildren?: ReactNode;
    hasDefault?: boolean;
    titleContent?: string;
}

export const SelectYourNumber = (props: IParams) => {
    const { children, noServiceChildren, hasDefault = true, titleContent } = props;
    const { t } = useTranslation(["glossary", "portinPage"]);
    const [showNoServiceChildren, setShowNoServiceChildren] = useState<boolean>(false);
    const {
        servicesList,
        selectedService,
        handleChangeSelectService,
        getSubscriptionListState,
        getServiceListState,
        getSubscriptionList,
    } = useGetSubscription(hasDefault, setShowNoServiceChildren);

    const handleChangePhoneNumber = (event: ChangeEvent<HTMLSelectElement>) => {
        const selectedPhoneNumber = parseInt(event.target.value);

        handleChangeSelectService(selectedPhoneNumber);
    };

    const onSelect = (selectValue: string | number) => {
        const service = selectValue && servicesList.find(({ value }) => value.id === selectValue);

        return service ? service.label : t("glossary:selectPhoneNumber");
    };

    const displayChildren =
        !getSubscriptionListState.error &&
        !getServiceListState.error &&
        !getSubscriptionListState.isLoading &&
        !getServiceListState.isLoading &&
        servicesList.length > 0;

    return (
        <Fragment>
            <Card className="select-number">
                <CardContent className="select-number-content">
                    <HandleErrorAndLoading
                        error={getSubscriptionListState.error ?? getServiceListState.error}
                        isLoading={getSubscriptionListState.isLoading || getServiceListState.isLoading}
                        retryFetch={getSubscriptionList}
                    >
                        <form className="select-number_form">
                            {servicesList.length <= 1 && (
                                <Grid container justify="center" spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography color="inherit" variant="h4">
                                            {titleContent ?? t("portinPage:yourPhoneNumber")}:
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography color="inherit" variant="h5">
                                            {servicesList.length
                                                ? servicesList[0].label
                                                : t("portinPage:noPhoneNumber")}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )}
                            {servicesList.length > 1 && (
                                <Grid container justify="center" spacing={2}>
                                    <Grid item xs={12}>
                                        <InputLabel htmlFor="filled-number">
                                            {titleContent ?? t("glossary:wantToSeeDetails")}:
                                        </InputLabel>
                                    </Grid>
                                    <Grid item sm={7} xs={9}>
                                        <Select
                                            aria-label="Number select"
                                            disableUnderline
                                            displayEmpty
                                            fullWidth
                                            id="filled-number"
                                            renderValue={onSelect}
                                            value={selectedService ? selectedService.id : ""}
                                            variant="filled"
                                            onChange={handleChangePhoneNumber}
                                        >
                                            {servicesList.map((phoneNumber) => (
                                                <MenuItem key={phoneNumber.value.id} value={phoneNumber.value.id}>
                                                    {phoneNumber.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                </Grid>
                            )}
                        </form>
                    </HandleErrorAndLoading>
                </CardContent>
            </Card>
            {displayChildren && children}
            {showNoServiceChildren && noServiceChildren}
        </Fragment>
    );
};
